<template>
  <div class="form_box">
    <div class="result">
      <img src="../../assets/images/form3.jpg" alt="" />
      <div class="control">
        <div class="control_close" v-if="isControlOpening">投票通道已<b style="color:green;">开启</b> <span @click="changeControlStatus(0)">点击关闭</span></div>
        <div class="control_open" v-else>投票通道已<b style="color:red;">关闭</b> <span @click="changeControlStatus(1)">点击打开</span></div>
      </div>
      <div class="allresult" v-if="resultList.all_result">
        <div class="item">
          <div class="title">投票结果</div>
          <div v-for="(item, index) in resultList.all_result.list" :key="item.id" style="padding-bottom:10px;">
            <div class="title" style="font-size:16px;margin-top:10px;">{{index + 1}}. {{item.section}}</div>
            <div v-for="(person, index) in item.result" :key="index" class="all">
            <!-- <div v-for="(person, index) in item.result" :key="index" class="all" v-show="person.cnt === Math.max.apply(Math, item.result.map(function(o) {return o.cnt}))"> -->
              <!-- <div class="num red" v-if="index === 0">{{index + 1}}</div>
              <div class="num orange" v-if="index === 1 || index === 2">{{index + 1}}</div>
              <div class="num" v-if="index > 2">{{index + 1}}</div> -->
              <div class="all_person">
                <img :src="person.vote_student_avatar" alt="" v-show="person.vote_student_avatar">
                <div class="all_person_intro">
                  <div class="name">{{person.vote_student_name}}</div>
                  <div class="line">
                    <div class="line_white">
                      <div class="line_gray" :style="'width:' + person.cnt/item.total*100 +'%'"></div>
                    </div>
                    <div class="persent">{{person.cnt}}票</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */ 
import Swal from 'sweetalert2'
export default {
  data () {
    return {
      showModal: true,
      formList: [], //投票项
      modelList: {},
      registerData: '',
      voted: false,
      jwt_token: '',
      wxlogin_token: '',
      resultList: {},
      isSuccess: false,
      voting: false,
      isControlOpening: true
    }
  },
  created () {
    this.getControlStatus()
    this.refreshResult()
  },
  methods: {
    getControlStatus: function () {
      let self = this
      self.$http.post('https://pyapi.gasauniversity.com/v3/agm/vote_status')
      .then(function (res) {
        // console.log(res)
        self.isControlOpening = res.data.enable
      })
      .catch(function (err) {
        console.log(err)
      })
    },
    changeControlStatus: function (num) {
      let enable
      let self = this
      if (num === 0) {
        enable = false
      } else if (num === 1){
        enable = true
      }
      Swal.fire({
        text: '是否确定更改投票状态',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '是',
        cancelButtonText: '否',
      }).then((result) => {
        if (result.isConfirmed) {
          self.$http.post('https://pyapi.gasauniversity.com/v3/agm/enable_vote', {
            enable : enable
          })
          .then(function (res) {
            // console.log(res)
            if (res.data.code === 0) {
              Swal.fire({
                icon: 'success',
                text: '更改成功',
              })
              self.getControlStatus()
            }
          })
          .catch(function (err) {
            console.log(err)
            Swal.fire({
              icon: 'error',
              text: '更改失败',
            })
          })
        }
      })
    },
    refreshResult: function () {
      let self = this
      this.$http.get('https://pyapi.gasauniversity.com/v3/agm/result')
      .then(function (res) {
        self.isSuccess = true
        let json_result = res.data
        //rebuild viewmodel for vote result
        self.resultList = json_result
      })
      .catch(function (err) {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import "vote.page.less";
</style>


// WEBPACK FOOTER //
// src/pages/vote/vote.page.vue